import { Injectable, signal, WritableSignal } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class FaceInteractionService {
    $focusedFaceId: WritableSignal<string | null> = signal(null);
    $hoveredFaceId: WritableSignal<string | null> = signal(null);

    public scrollToName(faceId: string): void {
        const faceTagId: string = `${faceId}-0`;

        const tag = document.getElementById(faceTagId);
        const control = document.getElementById(faceId);

        if (tag) {
            this.scrollAndFocus(tag, faceId);
        }

        if (control) {
            this.scrollAndFocus(control, faceId);
        }
    }

    private scrollAndFocus(element: HTMLElement, faceId: string) {
        element.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'nearest'
        });

        const parentEl: HTMLElement = element.closest('dd') as HTMLElement;
        if (element.tagName === 'P') {
            // Empty tag
            setTimeout(() => this.flashHighlight(parentEl), 300);
            (document.activeElement as HTMLElement | null)?.blur();
            this.setFaceFrameFocus(faceId);
            return;
        }

        setTimeout(() => this.flashHighlight(element), 300);
        element.focus({ preventScroll: true });
    }

    public setFaceFrameFocus(faceId: string | null) {
        this.$focusedFaceId.set(faceId);
    }

    public setFaceFrameHover(faceId: string | null) {
        this.$hoveredFaceId.set(faceId);
    }

    private flashHighlight(el: HTMLElement) {
        el.classList.add('sh-flash-highlight');

        function handleAnimationEnd() {
            el.classList.remove('sh-flash-highlight');
            el.removeEventListener('animationend', handleAnimationEnd);
        }

        el.addEventListener('animationend', handleAnimationEnd);
    }
}
